<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="800" transition="dialog-bottom-transition">
    <v-card outlined class="modern-card overflow-hidden elevation-24">
      <v-sheet color="secondary" class="pa-6 d-flex align-center shadow-sm">
        <v-avatar color="secondary lighten-1" size="32" class="mr-4">
          <v-icon small color="white">fas fa-history</v-icon>
        </v-avatar>
        <span class="text-h6 white--text font-weight-black text-uppercase tracking-widest">Trazabilidad Técnica</span>
        <v-spacer></v-spacer>
        <v-btn icon color="white" small @click="$emit('input', false)" class="grey lighten-1 opacity-20">
          <v-icon x-small>fas fa-times</v-icon>
        </v-btn>
      </v-sheet>
      <v-card-text class="pa-0">
        <detail-prestages :product="product" :work-order-id="workOrderId" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-6 bg-grey-light justify-end">
        <v-btn depressed color="secondary" class="rounded-lg font-weight-bold px-8" @click="$emit('input', false)">Entendido</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DetailPrestages from '@/components/production/DetailPrestages.vue'

export default {
  name: 'DetailPrestagesDialog',
  components: { DetailPrestages },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    workOrderId: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
  background-color: #fff;
}
.bg-grey-light {
  background-color: #f8f9fa;
}
.shadow-sm {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}
.opacity-20 {
  opacity: 0.2;
}
.tracking-widest {
  letter-spacing: 2px;
}
</style>
